import { z } from "zod";

export const ZodBigInt = z.bigint();
